export type SelectSegmentWriteKeyArgs = {
  isKiosk: boolean;
  isAppWebView: boolean;
  segmentIdKiosk: string;
  segmentIdApp: string;
  segmentIdWeb: string;
};

/**
 * Picks the Segment write key (i.e. the Segment source) for the current request.
 *
 * Precedence: kiosk, then app, then web. The kiosk branch only wins when a kiosk
 * write key is actually present, so any environment without a kiosk source (dev,
 * preview) transparently falls back to the web source instead of initialising
 * Segment with an empty write key. Do not simplify away the `&& segmentIdKiosk`
 * guard — it is what makes that fallback work.
 */
export const selectSegmentWriteKey = ({
  isKiosk,
  isAppWebView,
  segmentIdKiosk,
  segmentIdApp,
  segmentIdWeb,
}: SelectSegmentWriteKeyArgs): string => {
  if (isKiosk && segmentIdKiosk) return segmentIdKiosk;
  if (isAppWebView) return segmentIdApp;
  return segmentIdWeb;
};
